export const STICKY_HEADER_HEIGHT = 98;
